import { createNavigationItem, type NavigationItem } from './side-nav-items';

export type NavigationUserType = 'agent' | 'agency' | 'team';

export const getOverview = (): NavigationItem => createNavigationItem('overview', '/', 'dashboard');
export const getProfile = (): NavigationItem => createNavigationItem('editProfile', '/profile', 'account_circle');
